



































import { Component, Watch, Prop } from 'vue-property-decorator'

import FoldingCard from '@/components/FoldingCard.vue'
import detail from '@/modules/Account/views/detail.vue'
import Vue from 'vue'

@Component({
  components: {
    FoldingCard
  }
})
export default class AccountDetailSource extends Vue {
  @Prop({ type: Object, default: () => {} }) readonly account: any

  routeToProducerDetail () {
    return {
      name: 'ProducerDetailDetail',
      params: {
        id: this.account.source.id + ''
      }
    }
  }

  routeToBookDetail () {
    return {
      name: 'BookDetailDetail',
      params: {
        id: this.account.book.id + ''
      }
    }
  }
}
